"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _label = _interopRequireDefault(require("./label/label"));

var _info = _interopRequireDefault(require("./info/info"));

var _errormessage = _interopRequireDefault(require("./errormessage/errormessage"));

var _index = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _field_styles = _interopRequireDefault(require("./field_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
//READ BEFORE IMPLEMENTING THIS COMPONENT
//  If your form has a discard state that leaves the user on the form page rather than navigating them to another page, you must
//  pass the formDisabled prop which contains the editable state of the form (to prevent error messaging during disabled state).
//  For an example implementation, see: pages/dashboard/general/general.js.

/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD ~~~~~~~~~~ ========== */


var Field = function Field(props) {
  /////  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  DISPLAY  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  /////
  var displayLabel = function displayLabel() {
    return props.label ? _react.default.createElement(_label.default, null, props.label) : null;
  };

  var displayIcon = function displayIcon() {
    return props.icon ? _react.default.createElement("span", {
      className: "fieldicon"
    }, props.icon) : null;
  };

  var displayInfo = function displayInfo() {
    return props.info ? _react.default.createElement(_info.default, null, props.info) : null;
  };

  var displayErrorMessage = function displayErrorMessage() {
    // Need to pass the results of getErrorMessage down as prop to Field for this function from Everyone
    return !props.required ? null : props.valid === false ? _react.default.createElement(_errormessage.default, null, props.errorMessage) : null;
  };

  return _react.default.createElement("div", {
    className: "field ".concat((0, _index.generateClasses)(props, ['icon']), " isActive-").concat(props.active, " disabled-").concat(props.disabled, " isValid-").concat(props.valid, " hasValue-").concat(props.hasValue, " ").concat(props.classes.field)
  }, displayLabel(), props.test, _react.default.createElement("div", {
    className: "formelement"
  }, displayIcon(), _react.default.createElement("span", {
    className: "element"
  }, props.component)), displayInfo(), displayErrorMessage());
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var _default = (0, _reactJss.default)(_field_styles.default)(Field);

exports.default = _default;